import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "desktop"
}
const _hoisted_2 = { class: "gav-banner-warning gav-banner-text-normal" }
const _hoisted_3 = { class: "gav-banner-start2 align-self-center" }
const _hoisted_4 = { class: "gav-banner-mobile-label" }
const _hoisted_5 = { class: "gav-banner-flex-row" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "gav-banner-start5 gav-banner-flex-row align-self-center" }
const _hoisted_8 = { class: "gav-banner-picture" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "align-self-center" }
const _hoisted_11 = { class: "gav-banner-text-normal" }
const _hoisted_12 = { class: "gav-banner-contact-col2 align-self-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "gav-banner-start10 gav-banner-text-normal gav-banner-align-self-center" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "gav-banner-start12" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "button button--round-arrow button--borderless" }, null, -1)
const _hoisted_19 = { class: "gav-banner-collapsed" }
const _hoisted_20 = { class: "rotate-text" }
const _hoisted_21 = { class: "gav-banner-text-normal" }
const _hoisted_22 = { class: "gav-banner-start2 align-self-center" }
const _hoisted_23 = { class: "gav-banner-mobile-label" }
const _hoisted_24 = { class: "gav-banner-flex-row" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "gav-banner-mobile-buttons" }
const _hoisted_27 = ["href"]
const _hoisted_28 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.locationSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["gav-banner-grid", _ctx.editMode? 'gav-banner-edit' : 'gav-banner'])
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_2, " This component is only displayed if the website visitor already chose a preferred location, or if there is a location nearby. ", 512), [
              [_vShow, _ctx.editMode]
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.translations.yourClosestLocation), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  class: "button button--link gav-banner-mobile-link",
                  href: _ctx.link
                }, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.locationSelected.description), 1)
                ], 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.gavilon.getImage(_ctx.locationSelected.contact.image),
                  onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gavilon.removeImage && _ctx.gavilon.removeImage(...args))),
                  class: "location-box-image"
                }, null, 40, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.locationSelected.contact.name), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.locationSelected.contact.title), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.locationSelected.contact.phone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, " T: " + _toDisplayString(_ctx.locationSelected.contact.phone), 1))
                  : _createCommentVNode("", true),
                (_ctx.locationSelected.contact.email)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "button button--link",
                      href: `mailto:${_ctx.locationSelected.contact.email}`,
                      rel: "noopener noreferrer"
                    }, _toDisplayString(_ctx.translations.sendMessage), 9, _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                href: `${_ctx.link}/${_ctx.locationSelected.description}`,
                title: "See more details",
                class: "button"
              }, _toDisplayString(_ctx.translations.seeMoreDetails), 9, _hoisted_16)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapsed && _ctx.toggleCollapsed(...args))),
                class: "gav-banner-flex-row"
              }, [
                _createElementVNode("div", null, _toDisplayString(_ctx.translations.minimize), 1),
                _hoisted_18
              ])
            ])
          ], 2), [
            [_vShow, !_ctx.collapsed || _ctx.editMode]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.collapsed = !_ctx.collapsed; _ctx.saveCookies()}),
              class: "button button--round-arrow button--borderless rotate-icon"
            }),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", null, _toDisplayString(_ctx.translations.yourLocation), 1),
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.locationSelected.description), 1)
            ])
          ], 512), [
            [_vShow, _ctx.collapsed && !_ctx.editMode]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.locationSelected && _ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["gav-banner-grid mobile", _ctx.editMode? 'gav-banner-edit' : 'gav-banner'])
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "button button--cross button--borderless right-top",
              onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.closeBanner(); _ctx.saveCookies()})
            }),
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.translations.yourClosestLocation), 1),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("a", {
                class: "button button--link gav-banner-mobile-link",
                href: _ctx.link
              }, [
                _createElementVNode("div", null, _toDisplayString(_ctx.locationSelected.description), 1)
              ], 8, _hoisted_25),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("a", {
                  class: "button button--phone ml-16 mobile",
                  href: 'tel:+'+_ctx.locationSelected.contact.phone,
                  rel: "noopener noreferrer"
                }, _toDisplayString(_ctx.translations.call), 9, _hoisted_27),
                _createElementVNode("a", {
                  class: "button button--mail ml-16 mobile",
                  href: 'mailto:'+_ctx.locationSelected.contact.email,
                  rel: "noopener noreferrer"
                }, _toDisplayString(_ctx.translations.email), 9, _hoisted_28)
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}